import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

const Wrapper = styled(Link)`
	display: inline-block;
	border: 2px solid transparent;
	border-top-color: transparent;
	border-right-color: transparent;
	border-bottom-color: transparent;
	border-left-color: transparent;
	padding: 10px 20px;
	border-radius: 30px;
	font-weight: 500;
	font-size: 16px;
	letter-spacing: 0.5px;
	cursor: pointer;
	text-decoration: none;

	background-color: ${props => 
		props.variant === "blue" ? "#0D609D" :
		props.variant === "white-o" ? "#ffffff14" :
		"#000000"
	};
	border-color: ${props => 
		props.variant === "blue" ? "#0D609D" :
		props.variant === "white-o" ? "#ffffff" :
		"#000000"
	};
	color: ${props => 
		props.variant === "blue" ? "#ffffff" :
		props.variant === "white-o" ? "#ffffff" :
		"#ffffff"
	} !important;

	&:hover{
		background-color: ${props => 
			props.variant === "blue" ? "#ffffff" :
			props.variant === "white-o" ? "#ffffff" :
			"#ffffff"
		};
		border-color: ${props => 
			props.variant === "blue" ? "#0D609D" :
			props.variant === "white-o" ? "#ffffff" :
			"#000000"
		};
		color: ${props => 
			props.variant === "blue" ? "#0D609D" :
			props.variant === "white-o" ? "#0D609D" :
			"#000000"
		} !important;		
	}
`;


const Button = ({variant = "blue", background=null, onClick=() => {}, align="left", to, lightbox=false, children}) => {
  return (
    <Wrapper to={to} variant={variant} onClick={onClick}>
		{children}      
    </Wrapper>
  )
}

export default Button;
